export const environment = {
  production: true,
  api_uri: 'https://api.my.develop.taxtank.com.au',
  apiV2: 'https://api.my.develop.taxtank.com.au/api',
  coreLogicUrl: 'https://api-uat.corelogic.asia',
  coreLogicId: 'e792a0d2',
  coreLogicSecret: 'd02899957e3e59d82f59555b75095c98',
  intercomAppId: 'cljp47bm',
  stripePk: 'pk_test_51R3dirQUGlvvR3wdRdttUtPJ9MmVrRn03WGtxqaviVFkzEUnySqW2RRTzMRGUtj2SjOml1DcDoCZ4NvKVG8hzIFW00IhBPkgE8',
  mercureUrl: 'https://mercure.develop.taxtank.com.au/.well-known/mercure',
  logoutTimeout: 2700, // 45 minutes
  enableMixpanel: false,
  // Sentry
  app_uri: 'https://my.develop.taxtank.com.au',
  SENTRY_DSN: 'https://34de4f55cd5240a5bc9dc732c45bb82c@o343510.ingest.sentry.io/5839664',
  SENTRY_PROJECT: 'ttfront-dev',
  gtmId: '',
  // Social login
  facebookAppId: '3135372090062634',
  googleClientId: '1032292969842-ck57r927er88kbgpci582kbil4nevqgh.apps.googleusercontent.com',
  rewardfulId: '',
  googleAPIKey: 'AIzaSyDGdETttfBs5sDMZoaQT8fYO-pGLVi1oH4',
  tutorialPlaylistId: 'PLaibkGQwSaMp8kX9ndHgG7V4ybWHesHPN',
  playlistId: 'PLaibkGQwSaMp8kX9ndHgG7V4ybWHesHPN',
  accountantPlaylistId: 'PLaibkGQwSaMrKl2QsqlpPwIfXfKeShN4H',
  advisorPlaylistId: 'PLaibkGQwSaMqRNmA9WZ1U316jjzm8t4KM',
  // TaxTank support email (tt advisor account)
  ttAdvisor: 'help_dev@taxtank.com.au',
  ttAccountant: 'ITP_Staging@taxtank.com.au',
  mixpanelToken: '5affdbb53142b70b9faddfbf994cbaf8',
  sharesightUrl: 'https://edge-api.sharesight.com',
  sharesightClientId: '8062bba34024594b5370fb70832847f625430b48faae140d7fed4f8d502fe7af',
  sharesightRedirectUri: 'https://my.develop.taxtank.com.au/client/holdings-tank',
};
